import styled from 'styled-components';
import { shade } from 'polished';

interface SubmitStatus {
  success: boolean;
}

export const Container = styled.section`
  padding: 20px;
  padding-top: 30px;
  padding-bottom: 100px;

  max-width: 1200px;
  margin: 0 auto;

  display: flex;
  flex: 1;

  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

// ---> Start Form <---
export const FormContainer = styled.div`
  padding-right: 15px;

  h1 {
    font-weight: 800;
    font-size: 60px;
    line-height: 90px;

    color: #272727;
  }

  span {
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;

    color: #272727;
  }

  @media only screen and (max-width: 1000px) {
    text-align: center;
    padding-right: 0px;
    align-self: center;

    h1 {
      font-size: min(9vw, 60px);
      line-height: min(9vw, 90px);
    }

    span {
      font-size: min(3.3vw, 20px);
      line-height: min(15vw, 60px);
    }
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;

  margin-top: 50px;
  padding-right: 65px;

  input {
    border-width: 0 0 2px 0;
    border-color: #272727;

    font-family: Poppins;
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;
    padding: 5px;
    padding-left: 15px;

    text-transform: uppercase;
    color: #272727;

    ::placeholder {
      color: #7d7d7d;
    }

    & + input {
      margin-top: 25px;
    }
  }

  textarea {
    margin-top: 25px;
    border-width: 2px;
    border-color: #272727;
    resize: none;
    height: 200px;
    border-radius: 8px;

    font-family: Poppins;
    font-weight: normal;
    font-size: 18px;
    line-height: 27px;
    padding-top: 10px;
    padding-left: 15px;

    color: #272727;

    ::placeholder {
      color: #7d7d7d;
    }
  }

  @media only screen and (max-width: 1000px) {
    max-width: 500px;
    max-width: none;
    padding-right: 0px;
    margin-top: 25px;
  }
`;

export const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;

  button {
    font-weight: bold;
    font-size: 18px;
    line-height: 27px;

    text-transform: uppercase;

    color: #ffffff;

    width: 150px;
    height: 60px;

    background: #272727;
    border-width: 0px;
    border-radius: 10px;

    transition: background 0.2s;

    :hover {
      background: ${shade(0.6, '#272727')};
    }
  }

  @media only screen and (max-width: 1000px) {
    padding-right: 0px;
    flex-direction: column-reverse;
  }
`;

export const SubmitStatus = styled.p<SubmitStatus>`
  font-weight: bold;
  font-size: 20px;
  line-height: 30px;

  text-align: center;

  color: ${({ success }) => (success ? '#46C619' : '#C61919')};

  @media only screen and (max-width: 1000px) {
    margin-top: 20px;
    font-size: min(5vw, 20px);
    line-height: min(4vw, 30px);
  }
`;
// ---> End Form <---

// ---> Start Description <---
export const DescriptionContainer = styled.div`
  display: flex;
  flex: 1;

  align-items: flex-start;
  justify-content: flex-end;

  padding-top: 42px;

  @media only screen and (max-width: 1000px) {
    align-items: center;
    justify-content: center;

    padding-top: 0px;
  }
`;

export const DescriptionContent = styled.div`
  max-width: 350px;

  h1 {
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;

    color: #7d7d7d;
  }

  p {
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    text-align: justify;

    color: #272727;

    margin-top: 50px;
  }

  @media only screen and (max-width: 1000px) {
    margin-top: 30px;
    max-width: 580px;

    text-align: center;
  }
`;

export const DescriptionSocialContacts = styled.div`
  margin-top: 50px;

  h2 {
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;

    color: #272727;

    & + h2 {
      margin-top: 13px;
    }
  }

  @media only screen and (max-width: 1000px) {
    h2 {
      font-size: min(5vw, 18px);
      line-height: min(6vw, 25px);
    }

    p {
      font-size: min(4vw, 15px);
      line-height: min(5vw, 22px);
    }
  }
`;

export const SocialContainer = styled.div`
  margin-top: 13px;

  div {
    margin-top: 13px;

    a {
      svg {
        cursor: pointer;
        transition: fill 0.2s;
        fill: #272727;

        :hover {
          fill: #386882;
        }
      }

      & + a {
        margin-left: 15px;
      }
    }
  }

  @media only screen and (max-width: 1000px) {
    h1 {
      font-size: min(5vw, 18px);
      line-height: min(6vw, 25px);
    }
  }
`;
// ---> End Description <---
